module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("选配列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAddNew
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productDetailId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "选配名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "结算方式"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.accessoryType == 1) ? _c('span', [_vm._v("按次")]) : _vm._e(), _vm._v(" "), (_vm.row.accessoryType == 2) ? _c('span', [_vm._v("按天")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rental",
      "label": "价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deposit",
      "label": "押金"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "设备数量",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOnline(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleAdd(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("添加")])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          staticClass: "demo-table-expand",
          attrs: {
            "data": props.row.deviceArr,
            "inline": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "productIdentity",
            "label": "选配编码"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "storageArr.storageName",
            "label": "所在仓库"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "context": _vm._self,
            "label": "状态"
          },
          inlineTemplate: {
            render: function() {
              var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
                return _c('div', [(_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])])
              
            },
            staticRenderFns: []
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "context": _vm._self,
            "width": "200",
            "label": "操作"
          },
          inlineTemplate: {
            render: function() {
              var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
                return _c('span', [_c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleView(_vm.$index, _vm.row.rentHistory)
                    }
                  }
                }, [_vm._v("查看租赁历史")]), _vm._v(" "), _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editDevice(_vm.$index, props.row.deviceArr)
                    }
                  }
                }, [_vm._v("编辑")]), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleOnlined(_vm.$index, props.row.deviceArr, props.row)
                    }
                  }
                }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
                  attrs: {
                    "type": "text",
                    "size": "small"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.handleOffd(_vm.$index, props.row.deviceArr, props.row)
                    }
                  }
                }, [_vm._v("下架")]) : _vm._e()], 1)
              
            },
            staticRenderFns: []
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "租赁历史",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户ID",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUserId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一个租赁客户姓名",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderUsername))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上一次租赁订单号",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.lastOrderNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间",
      "label-width": "150px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁次数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.orderCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁天数",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.dayCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "累计租赁资金",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.rentalSum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe16f64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/OptionalList.vue
// module id = 741
// module chunks = 1